<template>
  <div class="search-main">
    <Form
      ref="searchForm"
      :model="formInline"
      label-position="right"
      :label-width="0"
      inline
      style="position: relative; margin-bottom: 8px"
      class="search-list-430 search-wrapper-430"
    >
      <FormItem label="">
        <ChooseApply
          :placeholder="`请选择学校`"
          :yearTermCode="[formInline.yearCode, formInline.termCode]"
          :clearable="true"
          :orgType="`1`"
          ref="chooseSchoolRef"
          v-if="portOrg != 2"
        ></ChooseApply>
        <p v-else>{{ userInfo && userInfo.orgName }}</p>
      </FormItem>
      <FormItem label="">
        <CascaderYearTerms
          ref="cascaderYearTerms"
          :placeholder="`请选择学期`"
          @on-init="onInitChange"
          @on-change="onCascaderChange"
        ></CascaderYearTerms>
      </FormItem>

      <FormItem label="">
        <ChooseApply
          :placeholder="`请选择机构`"
          :yearTermCode="[formInline.yearCode, formInline.termCode]"
          :clearable="true"
          :orgType="``"
          ref="chooseApplyRef"
          v-if="portOrg != 3"
        ></ChooseApply>
        <p v-else>{{ userInfo && userInfo.orgName }}</p>
      </FormItem>
      <FormItem label="">
        <Select
          v-model="formInline.orgFileStatus"
          placeholder="机构上传状态"
          class="search-select-430"
          clearable
        >
          <Option value="1">已上传</Option>
          <Option value="0">待上传</Option>
        </Select>
      </FormItem>

      <FormItem label="" v-if="portOrg != 3">
        <Select
          v-model="formInline.platFileStatus"
          placeholder="平台上传状态"
          class="search-select-430"
          clearable
        >
          <Option value="1">已上传</Option>
          <Option value="0">待上传</Option>
        </Select>
      </FormItem>

      <FormItem label="" v-if="portOrg != 3">
        <Select
          v-model="formInline.schoolFileStatus"
          placeholder="学校上传状态"
          class="search-select-430"
          clearable
        >
          <Option value="1">已上传</Option>
          <Option value="0">待上传</Option>
        </Select>
      </FormItem>
      <FormItem label="" v-if="portOrg != 3">
        <Select
          v-model="formInline.templateSts"
          placeholder="请选择模版状态"
          class="search-select-430"
          clearable
        >
          <Option value="1">已启用</Option>
          <Option value="0">已停用</Option>
        </Select>
      </FormItem>
      <Button type="primary" @click="handleSearch">查询</Button>
      <Button class="search-430" @click="handleReset">重置</Button>
    </Form>
  </div>
</template>
<script>
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';
export default {
  components: {
    CascaderYearTerms,
    ChooseApply
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      portOrg: Number(localStorage.getItem('portOrg')),
      formInline: {
        orgId: '',
        schoolId: '',
        yearCode: '',
        termCode: '',
        templateSts: '',
        schoolFileStatus: '',
        platFileStatus: '',
        orgFileStatus: '',
      }
    }
  },
  methods: {
    handleSearch() {
      this.$emit('on-search', this.getParameter())
    },
    handleReset() {
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear()
      this.$refs.chooseSchoolRef && this.$refs.chooseSchoolRef.handleClear()
      this.$refs.cascaderYearTerms && this.$refs.cascaderYearTerms.handleDefault()
      for (let k in this.formInline) {
        this.formInline[k] = ''
      }

    },
    getParameter() {
      this.formInline.orgId = this.portOrg != 3 ? this.$refs.chooseApplyRef.getResult().orgId : this.userInfo.orgId
      this.formInline.schoolId = this.portOrg != 2 ? this.$refs.chooseSchoolRef.getResult().orgId : this.userInfo.orgId
      if (this.$refs.cascaderYearTerms) {
        const yearTerms = this.$refs.cascaderYearTerms.getResult();
        this.formInline.yearCode = yearTerms[0]
        this.formInline.termCode = yearTerms[1]
      }
      return {
        ...this.formInline
      }
    },
    onCascaderChange(val) {
      this.formInline.yearCode = val[0];
      this.formInline.termCode = val[1];
    },
    onInitChange(val) {
      this.formInline.yearCode = val[0];
      this.formInline.termCode = val[1];
      this.handleSearch()
    }

  }
}
</script>